/**
 *
 * /Login
 *
 */

import React, { memo, useRef, useEffect, useState } from 'react'
import { flushSync } from 'react-dom'
import Vanta from 'vanta/dist/vanta.net.min'

// NPM Libraries
import styled from '@emotion/styled'

// Components
import LoginForm from 'components/LoginForm'

import { COLORS } from 'global-styles'

// Utils
import wavify from 'utils/wavify'
import 'utils/TweenMax.min'

const LoginContainer = styled.div`
	height: 100%;
	/* background-image: linear-gradient(-90deg, #397ae9 15%, #4789e1 24%, #adf2ab 140%); */
	background-color: #000;
	position: relative;

	display: flex;
	align-items: center;
	justify-content: center;

	.wave {
		position: absolute;
	}
`

const FormWrapper = styled.div`
	// position: absolute;
	// right: 0;
	// top: 0;
	// bottom: 0;
	background-color: #fff;
	// width: 50%;
	min-width: 320px;
	overflow: auto;
	z-index: 2;
	border-radius: 0.25rem;

	@media screen and (max-width: 500px) {
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		left: 0;
		padding-top: 20%;
	}
`

const Terms = styled.div`
	text-align: center;
	font-size: 80%;
	margin-bottom: 1rem;
`

function Login() {
	// const wavify1 = useRef()
	// const wavify2 = useRef()
	// const wavify3 = useRef()
	// const wavify4 = useRef()

	// useEffect(() => {
	// 	if (wavify1.current) {
	// 		wavify(wavify1.current, {
	// 			height: 250,
	// 			bones: 5,
	// 			amplitude: 175,
	// 			color: 'rgba(255, 255, 255, .5)',
	// 			speed: 0.12,
	// 		}) // eslint-disable-line indent, no-undef
	// 		wavify(wavify2.current, {
	// 			height: 450,
	// 			bones: 4,
	// 			amplitude: 150,
	// 			color: 'rgba(255, 255, 255, .5)',
	// 			speed: -0.08,
	// 		}) // eslint-disable-line indent, no-undef
	// 		wavify(wavify3.current, {
	// 			height: 550,
	// 			bones: 4,
	// 			amplitude: 100,
	// 			color: 'rgba(255, 255, 255, .5)',
	// 			speed: -0.1,
	// 		}) // eslint-disable-line indent, no-undef
	// 		wavify(wavify4.current, {
	// 			height: 600,
	// 			bones: 3,
	// 			amplitude: 200,
	// 			color: 'rgba(255, 255, 255, .5)',
	// 			speed: 0.13,
	// 		}) // eslint-disable-line indent, no-undef
	// 	}
	// }, [wavify1.current, wavify2.current, wavify3.current, wavify4.current])
	const [show, setShow] = useState(false)

	const [vantaEffect, setVantaEffect] = useState(null)
	const background_ref = useRef(null)
	useEffect(() => {
		if (!vantaEffect) {
			setVantaEffect(Vanta({
				el: background_ref.current,
				color: COLORS.primary,
			}))
		}
		return () => {
			if (vantaEffect) vantaEffect.destroy()
		}
	}, [vantaEffect])

	useEffect(() => {
		if (vantaEffect) {
			if (document.startViewTransition) {
				document.startViewTransition(() => {
					flushSync(() => {
						setShow(true)
					})
				})
			} else {
				setShow(true)
			}
		}
	}, [vantaEffect])

	return (
		<LoginContainer>
			{/* 
				<Molecule
					style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: '50%', height: '100%', zIndex: 1 }}
				/>
			*/}
			{/*
			<svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" className="wave">
				<defs></defs>
				<path id="wavify-1" ref={wavify1} d="" />
			</svg>
			<svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" className="wave">
				<defs></defs>
				<path id="wavify-2" ref={wavify2} d="" />
			</svg>
			<svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" className="wave">
				<defs></defs>
				<path id="wavify-3" ref={wavify3} d="" />
			</svg>
			<svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" className="wave">
				<defs></defs>
				<path id="wavify-4" ref={wavify4} d="" />
			</svg>
			*/}

			<div id="background-container" ref={background_ref} style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, width: '100%', height: '100%', zIndex: 1 }}>
				{/* <iframe
					src="https://d20gsr9hh45bpf.cloudfront.net/"
					title="Perlin Noise"
					style={{ height: '100%', width: '100%' }}
				/> */}
			</div>
			{show && (
				<FormWrapper>
					<div className="container-fluid" style={{ padding: '2em' }}>
						<div className="row">
							<div className="col-12 text-center">
								<div className="mx-auto mb-5" style={{ maxWidth: 150 }}>
									<img
										alt="LeadJig"
										className="img-fluid"
										src="https://s3.amazonaws.com/leadjig-resources/images/LeadJig+Black+Text.png"
									/>
								</div>
							</div>
						</div>
						<LoginForm />
					</div>
					<Terms>
						By logging in, you agree to our{' '}
						<a target="_blank" href="https://leadjig-resources.s3.amazonaws.com/terms-and-conditions.html">
							Terms and Conditions
						</a>{' '}
						and{' '}
						<a target="_blank" href="https://leadjig-resources.s3.amazonaws.com/privacy-policy.html">
							Privacy Policy
						</a>
						.
					</Terms>
				</FormWrapper>
			)}
		</LoginContainer>
	)
}

Login.propTypes = {}

export default memo(Login)
